export default "__VITE_ASSET__Qy9RMTzW__"